import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoMain from '../img/tasaciones_logo.png';
import logoLetter from '../img/tasacionesya_letter.png';
import { FaBars, FaTimes, FaUser, FaSignInAlt, FaUserPlus } from 'react-icons/fa';


const Navbar = ({ isLoggedIn, onLoginClick, onRegisterClick, onLogout, userInfo, onNavigateToMetrics, onNavigateToUsers, onAgentDashboardClick = () => {} }) => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLoginClick = (e) => {
        e.preventDefault();
        onLoginClick();
    };
    
    const handleRegisterClick = (e) => {
        e.preventDefault();
        setIsMenuOpen(false);
        onRegisterClick();
    };

    const handleLogout = (e) => {
        e.preventDefault();
        onLogout();
    };

    const handleMetricsClick = (e) => {
        e.preventDefault();
        onNavigateToMetrics();
    };
    
    const handleUsersClick = (e) => {
        e.preventDefault();
        onNavigateToUsers();
        setIsMenuOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Define the color codes
    const primaryColor = '#8360C3';
    const secondaryColor = '#2EBF91';

    // Inline styles
    const styles = {
        navbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 15px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderBottom: `1px solid ${primaryColor}`,
            width: '100%',
            boxSizing: 'border-box',
        },
        logoContainer: {
            display: 'flex',
            alignItems: 'center',
            flex: isMobile ? '1' : 'none',
            justifyContent: isMobile ? 'center' : 'flex-start',
        },
        letterContainer: {
            display: isMobile ? 'none' : 'flex',
            flex: 1,
            justifyContent: 'center',
        },
        loginLinkContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        logoImage: {
            height: '35px',
        },
        letterImage: {
            height: '35px',
        },
        loginLink: {
            textDecoration: 'none',
            color: primaryColor,
            marginLeft: '8px',
            paddingRight: '20px',
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
        },
        loginIcon: {
            marginRight: '5px',
        },
        hamburgerMenu: {
            display: isMobile ? 'block' : 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: primaryColor,
        },
        menuOpen: {
            display: isMenuOpen && isMobile ? 'block' : 'none',
            position: 'absolute',
            top: '60px',
            right: '10px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            padding: '10px',
            borderRadius: '4px',
            zIndex: '1000',
            width: '200px',
            boxSizing: 'border-box',
        },
        menuItem: {
            display: 'block',
            padding: '10px',
            textDecoration: 'none',
            color: secondaryColor,
        },
        desktopOnly: {
            display: isMobile ? 'none' : 'flex',
            alignItems: 'center',
        },
    };

    return (
        <>
            <div style={styles.navbar}>
                <div style={styles.logoContainer}>
                    <img 
                        src={logoMain} 
                        alt="Logo" 
                        style={styles.logoImage}
                    />
                </div>
                <div style={styles.letterContainer}>
                    <img 
                        src={logoLetter} 
                        alt="Valuaciones Letter" 
                        style={styles.letterImage}
                    />
                </div>
                <div 
                    style={styles.hamburgerMenu} 
                    onClick={toggleMenu}
                >
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                </div>
                <div style={styles.desktopOnly}>
                    {isLoggedIn ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {userInfo?.userType === 'Admin' && (
                                <a href="#" style={styles.loginLink} onClick={handleMetricsClick}>
                                    🏠 Mi portal
                                </a>
                            )}
                            {(userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && (
                                <>
                                    <span style={{ color: primaryColor, fontSize: '14px' }}>
                                        Hola, {userInfo?.name || userInfo?.email}
                                    </span>
                                    <a href="#" style={styles.loginLink} onClick={(e) => {
                                        e.preventDefault();
                                        onAgentDashboardClick();
                                    }}>
                                        🏠 Panel
                                    </a>
                                </>
                            )}
                            <a href="#" style={styles.loginLink} onClick={handleLogout}>
                                Cerrar sesión
                            </a>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <button
                                onClick={handleLoginClick}
                                style={{
                                    background: 'transparent',
                                    color: primaryColor,
                                    border: `2px solid ${primaryColor}`,
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = primaryColor;
                                    e.target.style.color = 'white';
                                    e.target.style.transform = 'translateY(-1px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(131, 96, 195, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'transparent';
                                    e.target.style.color = primaryColor;
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                <FaSignInAlt size={14} />
                                Ingresar
                            </button>
                            <button
                                onClick={handleRegisterClick}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.2)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-1px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.2)';
                                }}
                            >
                                <FaUserPlus size={14} />
                                Registrarse
                            </button>
                        </div>
                    )}
                </div>
                {isMenuOpen && (
                    <div style={styles.menuOpen}>
                        {isLoggedIn ? (
                            <div>
                                {(userInfo?.userType === 'agent' || userInfo?.userType === 'individual') && (
                                    <>
                                        <div style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                                            Hola, {userInfo?.name || userInfo?.email}
                                        </div>
                                        <a href="#" style={styles.menuItem} onClick={(e) => {
                                            e.preventDefault();
                                            setIsMenuOpen(false);
                                            onAgentDashboardClick();
                                        }}>
                                            🏠 Panel
                                        </a>
                                    </>
                                )}
                                {userInfo?.userType === 'Admin' && (
                                    <a href="#" style={styles.menuItem} onClick={(e) => {
                                        e.preventDefault();
                                        setIsMenuOpen(false);
                                        handleMetricsClick(e);
                                    }}>
                                        🏠 Mi portal
                                    </a>
                                )}
                                <a href="#" style={styles.menuItem} onClick={handleLogout}>
                                    Cerrar sesión
                                </a>
                            </div>
                        ) : (
                            <div>
                                <a href="#" style={{
                                    ...styles.menuItem,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    border: `2px solid ${primaryColor}`,
                                    borderRadius: '6px',
                                    color: primaryColor,
                                    fontWeight: '600',
                                    textAlign: 'center',
                                    padding: '10px'
                                }} onClick={handleLoginClick}>
                                    <FaSignInAlt size={14} />
                                    Ingresar
                                </a>
                                <a href="#" style={{
                                    ...styles.menuItem,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    borderRadius: '6px',
                                    marginTop: '8px',
                                    textAlign: 'center',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    padding: '10px 12px'
                                }} onClick={handleRegisterClick}>
                                    <FaUserPlus size={14} />
                                    Registrarse
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Navbar;
